export type Model = {
	name: string;
	keys: { [key: string]: { type: string, text: string } },
	example?: { [key: string]: string }
};

export const LIST_MODEL: Model = {
	name: 'List',
	keys: {
		data: { type: 'Array', text: 'Model' },
		total: { type: 'number', text: 'total items in DB' },
		page: { type: 'number', text: 'current page' },
		limit: { type: 'number', text: 'number of items on page' }
	}
};

export const USER_MODEL_PREVIEW: Model = {
	name: 'User',
	keys: {
		id: { type: 'string', text: 'autogenerated' },
		title: { type: 'string', text: '"mr", "ms", "mrs", "miss", "dr", ""' },
		firstName: { type: 'string', text: 'length: 2-50' },
		lastName: { type: 'string', text: 'length: 2-50' },
		picture: { type: 'string', text: 'url' },
	},
	example: {
		email: "heinz-georg.fiedler@example.com",
		firstName: "Heinz-Georg",
		id: "0F8JIqi4zwvb77FGz6Wt",
		lastName: "Fiedler",
		picture: "https://randomuser.me/api/portraits/men/81.jpg",
		title: "mr"
	}
};

export const USER_MODEL: Model = {
	name: 'User',
	keys: {
		id: { type: 'string', text: 'autogenerated' },
		title: { type: 'string', text: '"mr", "ms", "mrs", "miss", "dr", ""' },
		firstName: { type: 'string', text: 'length: 2-50' },
		lastName: { type: 'string', text: 'length: 2-50' },
		gender: { type: 'string', text: '"male", "female", "other", ""' },
		email: { type: 'string', text: 'email' },
		dateOfBirth: { type: 'string', text: 'ISO Date - value: 1/1/1900 - now' },
		registerDate: { type: 'string', text: 'autogenerated' },
		phone: { type: 'string', text: 'phone number - any format' },
		picture: { type: 'string', text: 'url' },
		location: { type: 'object', text: 'Location' },
	},
	example: {
		email: "heinz-georg.fiedler@example.com",
		firstName: "Heinz-Georg",
		id: "0F8JIqi4zwvb77FGz6Wt",
		lastName: "Fiedler",
		picture: "https://randomuser.me/api/portraits/men/81.jpg",
		title: "mr"
	}
};

export const LOCATION_MODEL: Model = {
	name: 'Location',
	keys: {
		street: { type: 'string', text: 'length: 5-100' },
		city: { type: 'string', text: 'length: 2-30' },
		state: { type: 'string', text: 'length: 2-30' },
		country: { type: 'string', text: 'length: 2-30' },
		timezone: { type: 'string', text: 'Valid timezone value ex. +7:00, -1:00' },
	}
};

export const POST_MODEL_CREATE: Model = {
	name: 'Post',
	keys: {
		text: { type: 'string', text: 'length: 6-50, preview only' },
		image: { type: 'string', text: 'url' },
		likes: { type: 'number', text: 'init value: 0' },
		tags: { type: 'array', text: 'string' },
		owner: { type: 'string', text: 'User id' }
	}
};

export const POST_MODEL_PREVIEW: Model = {
	name: 'Post',
	keys: {
		id: { type: 'string', text: 'autogenerated' },
		text: { type: 'string', text: 'length: 6-50, preview only' },
		image: { type: 'string', text: 'url' },
		likes: { type: 'number', text: 'init value: 0' },
		tags: { type: 'array', text: 'string' },
		publishDate: { type: 'string', text: 'autogenerated' },
		owner: { type: 'object', text: 'User Preview' }
	}
};

export const POST_MODEL: Model = {
	name: 'Post',
	keys: {
		id: { type: 'string', text: 'autogenerated' },
		text: { type: 'string', text: 'length: 6-1000' },
		image: { type: 'string', text: 'url' },
		likes: { type: 'number', text: 'init value: 0' },
		link: { type: 'string', text: 'url, length: 6-200' },
		tags: { type: 'array', text: 'string' },
		publishDate: { type: 'string', text: 'autogenerated' },
		owner: { type: 'object', text: 'User Preview' }
	}
};

export const TAG_MODEL: Model = {
	name: 'Tag',
	keys: {
		title: { type: 'string', text: 'length: 2-100' }
	}
};

export const COMMENT_CREATE: Model = {
	name: 'Comment',
	keys: {
		message: { type: 'string', text: 'length: 2-500' },
		owner: { type: 'string', text: 'User Id' },
		post: { type: 'string', text: 'Post Id' },
	}
};


export const COMMENT_MODEL: Model = {
	name: 'Comment',
	keys: {
		id: { type: 'string', text: 'autogenerated' },
		message: { type: 'string', text: 'length: 2-500' },
		owner: { type: 'object', text: 'User Preview' },
		post: { type: 'string', text: 'Post Id' },
		publishDate: { type: 'string', text: 'autogenerated' },
	}
};
